import { Typography } from '../../../../core/components/molecules/Typography';
import MemoryButton from '../memory-button';
import { Modal } from '../modal';

const ModalDeleteFlashcards = ({
  isOpen,
  onClose,
  onDelete,
}: {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <Typography className='dark:text-[#FFF]'>
          Excluir <i>Flashcards</i>?
        </Typography>
      }
      footer={
        <div className='flex flex-row gap-2'>
          <MemoryButton
            label='Cancelar'
            className='w-full'
            variant='outline'
            onClick={onClose}
            allowReadOnly
          />
          <MemoryButton
            label='Apagar'
            className='w-full'
            variant='primary'
            onClick={onDelete}
          />
        </div>
      }
    >
      <div className='flex flex-col gap-4'>
        <Typography className='text-h5 font-bold text-mono-color-darker'>
          Deseja excluir os <i>flashcards</i> selecionados?
        </Typography>
      </div>
    </Modal>
  );
};

export default ModalDeleteFlashcards;
